export const userReducer = (user = [], action) => {
  const { type, payload } = action;

  switch (type) {
    case "SAVE_TOKEN":
      const { accessToken } = payload;
      return {
        ...user,
        accessToken,
      };
    case "LOGOUT":
      localStorage.removeItem("SessionID");
      return {
        ...user,
        accessToken: null,
      };

    default:
      return user;
  }
};
